export const authAPIUrls = {
  login: '/auth/login',
} as const;